import { z } from 'zod';

/**
 * Zeichnungsnummer (Modul engineering, ADR 0031): Format `XXXX.YYYYY` =
 * {Warengruppe 4-stellig}.{laufende Nr. 5-stellig}. Wird direkt (ohne Freigabe)
 * angelegt — nur die spätere Artikelanlage ist vier-augen-pflichtig (PR C).
 * `number`/`runningNumber`/`commodityGroupCode` werden serverseitig vergeben.
 */
export const createDrawingNumberSchema = z.object({
  commodityGroupId: z.string().uuid(),
  description: z.string().trim().min(1).max(200),
  longTextDe: z.string().trim().max(4000).default(''),
  longTextEn: z.string().trim().max(4000).default(''),
  reference: z.string().trim().max(200).nullable().optional(),
  internalNote: z.string().trim().max(4000).nullable().optional(),
});
export type CreateDrawingNumberInput = z.infer<typeof createDrawingNumberSchema>;

export const drawingNumberResponseSchema = z.object({
  id: z.string().uuid(),
  number: z.string(),
  commodityGroupId: z.string().uuid(),
  commodityGroupCode: z.number().int(),
  runningNumber: z.number().int(),
  description: z.string(),
  longTextDe: z.string(),
  longTextEn: z.string(),
  reference: z.string().nullable(),
  internalNote: z.string().nullable(),
  createdAt: z.string().datetime(),
});
export type DrawingNumberResponse = z.infer<typeof drawingNumberResponseSchema>;
